/**
 * `src/lib/privacy/fetch.ts` — the one door out.
 *
 * Every network request the app makes goes through `appFetch`, so the list of
 * places the app talks to the network is one grep for `appFetch` (eslint's
 * `no-restricted-globals` rule forbids a bare `fetch`). Resolved through
 * `globalThis` on each call so tests and hosts can install their own.
 */
export function appFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
	return globalThis.fetch(input, init);
}
